/* esm.sh - applesauce-common@5.2.0/dist/helpers/blossom */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/blossom.mjs";
